import { useTranslation } from "react-i18next";
import { useBookDemo } from "../../../../hooks/useBookDemo";

  interface Plan {
    /** Key under `landing.pricing.*` in the translation files. */
    id: string;
    /** Number of `featureN` keys this plan has. */
    featureCount: number;
    highlight?: boolean;
    mostPopular?: boolean;
  }

  const plans: Plan[] = [
    { id: "essential", featureCount: 5 },
    { id: "professional", featureCount: 4 },
    { id: "custom", featureCount: 5, highlight: true, mostPopular: true },
  ];

  const ChooseSuitablePlan: React.FC = () => {
    const { t } = useTranslation();
    const openBookDemo = useBookDemo("landing_pricing");

    return (
      <div id="pricing" className="bg-offwhite px-5 py-[30px] md:py-20">
        <div className="text-center space-y-4 max-w-[716px] mx-auto">
          <h1 className="text-primary text-[32px] md:text-[48px] leading-10 md:leading-[58px] font-bold">
            {t("landing.pricing.title")}
          </h1>
          <p className="text-darkgray text-[16px] sm:text-[18px] leading-[28px] font-normal tracking-[0.01em]">
            {t("landing.pricing.subtitle")}
          </p>
        </div>
        <div className="mt-6 md:mt-12 max-w-[1006px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className="flex flex-col rounded-[20px] border border-bordercard transition-shadow duration-200 bg-white p-6 text-left relative"
            >
              <div className="flex items-center gap-2 mb-3">
                <h3 className="text-[24px] font-semibold leading-8 text-primary">
                  {t(`landing.pricing.${plan.id}.name`)}
                </h3>
                {plan.mostPopular && (
                  <span className="px-2 py-1 rounded-full bg-accent/10 text-seagreen text-[12px] leading-4 font-bold">
                    {t("landing.pricing.mostPopular")}
                  </span>
                )}
              </div>
              <p className="text-[#686873] text-[14px] leading-5 font-normal mb-6">
                {t(`landing.pricing.${plan.id}.description`)}
              </p>
              <ul className="flex flex-col mb-[62px] md:mb-[71px]">
                {Array.from({ length: plan.featureCount }, (_, i) => `feature${i + 1}`).map((featureKey) => (
                  <li
                    key={featureKey}
                    className="flex items-center gap-2 py-3 first:pt-0 last:pb-0 border-b last:border-b-0 border-[#E7E8EE]"
                  >
                    <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
                      <path
                        d="M6.75 13.5L2.25 9l1.06-1.06L6.75 11.38l7.94-7.94L15.75 4.5 6.75 13.5z"
                        fill="#12B76A"
                      />
                    </svg>
                    <span className="text-[14px] leading-5 text-primary font-medium">
                      {t(`landing.pricing.${plan.id}.${featureKey}`)}
                    </span>
                  </li>
                ))}
              </ul>
              <button 
                onClick={openBookDemo}
                className="mt-auto w-full rounded-xl h-12 text-[18px] leading-5 font-semibold transition-all duration-300 border bg-white text-secondary border-[#D0D5DD] hover:bg-accent hover:text-white hover:border-accent hover:-translate-y-0.5 hover:shadow-[0_10px_25px_rgba(15,23,42,0.16)] active:translate-y-0 active:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-offwhite"
              >
                {t("landing.pricing.requestPricing")}
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default ChooseSuitablePlan;
  